<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">WIFI Access Points</h1>
                <v-btn :disabled="!company" color="black"
                       prepend-icon="mdi-plus" @click="()=>{selectedConfig=null; dialogSwitch = true}">Add
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="user.type === 'admin'" cols="12" md="4" sm="6">
                <company-select v-model="company" :items="companies" density="compact" label="Select Company"
                          @update:model-value="fetchConfigs"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th-btn :sorted-column="sortedColumn??null" column="id"
                                sortable title="ID" @sort="sort"/>
                        <th-btn :sorted-column="sortedColumn??null" column="ssid"
                                sortable title="SSID" @sort="sort"/>
                        <th-btn :sorted-column="sortedColumn??null" column="access_point"
                                sortable title="Access Point Type" @sort="sort"/>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="config in configs" v-if="configs.length" :key="config.id" class="text-left">
                        <td>{{ config.id }}</td>
                        <td>{{ config.ssid }}</td>
                        <td>{{ types[config.access_point] }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editConfig(config)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete"
                                       size="x-small" @click="deleteConfig(config)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="3">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="3">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-pagination
                    v-model="currentPage"
                    :length="totalPages"
                    class="my-4"
                    density="compact"
                    @update:model-value="fetchConfigs"
                ></v-pagination>
            </v-col>
        </v-row>
    </v-container>

    <Create_Edit v-if="dialogSwitch"
                 v-model="dialogSwitch"
                 :company-id="company"
                 :config="selectedConfig"
                 @addConfig="addConfig"
                 @updateConfig="updateConfig"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import ThBtn from "@/components/globals/th-btn.vue";
import Create_Edit from "@/components/dialogs/configurations/Create_Edit.vue";
import CompanySelect from "@/components/globals/company-select.vue";

const type = ref(null)
const {user} = useAuthStore()
const companies = ref([]);
const configs = ref([]);
const loading = ref(false);
const totalPages = ref(1);
const currentPage = ref(1);
const dialogSwitch = ref(false);
const selectedConfig = ref(null);
const sortedType = ref(null);
const sortedColumn = ref(null);
const {showSnackbar} = useSnackbarStore();
const company = ref(user.type !== 'admin' ? user.company.id : null);
const types = {
    0: 'Connectivity',
    1: 'Location Awareness Only',
    2: 'Both',
};

onMounted(() => {
    if (user.type === 'admin') {
        fetchCompaniesList();
    } else {
        fetchConfigs();
    }
});
const fetchCompaniesList = () => {
    send('get', `companies/list`)
        .then((response) => {
            companies.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Companies List could not be loaded', 'error')
        })
}
const sort = (sorting) => {
    sortedColumn.value = sorting.column;
    sortedType.value = sorting.order;
    fetchConfigs();
}
const fetchConfigs = () => {
    if (company.value) {
        send('get', `configurations/wifi`, {
            page: currentPage.value,
            company: (user.type === 'admin') ? company.value : null,
            sort: sortedColumn.value,
            order: sortedType.value
        }).then((response) => {
            loading.value = false;
            configs.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
            .catch((error) => {
                console.log(error)
                showSnackbar('Wifi Configs could not be loaded', 'error')
            });
    }
}
const addConfig = (config) => {
    configs.value.unshift(config);
}
const editConfig = (config) => {
    selectedConfig.value = config;
    dialogSwitch.value = true;
}
const updateConfig = (config) => {
    configs.value.map((temp, index) => {
        if (temp.id === config.id) {
            configs.value[index] = config;
        }
    });
}
const deleteConfig = (config) => {
    if (confirm(`Are you sure to delete "${config.ssid}" config?`)) {
        send('delete', `configurations/wifi/${config.id}`)
            .then((response) => {
                if (response.data.success) {
                    configs.value.map((item, index) => {
                        if (item.id === config.id) {
                            configs.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${config.ssid}" Config could not be deleted`, 'error')
                }
            })
    }
}
</script>
